import { Input, InputProps } from 'antd';

export type InputAtomProps = InputProps;

const InputAtom = Input;

export default InputAtom;